(function($) {
    $.fn.eventify = function() {
        var now           = Date.now(),
            dateNow       = new Date(),
            dayNow        = dateNow.getUTCDate(),
            monthNowRaw   = dateNow.getMonth(),
            monthNow      = monthNowRaw + 1,
            yearNow       = dateNow.getFullYear();

        this.each(function() {
            var $event                         = $(this).find('.event-card-details'),
                eventDay                       = $event.data('day') * 1,
                eventMonth                     = $event.data('month') * 1,
                eventYear                      = $event.data('year') * 1,
                startTimestamp                 = $event.data('start-timestamp') * 1000,
                startTimestampMinus180seconds  = startTimestamp - 180000,
                endTimestamp                   = $event.data('end-timestamp') * 1000,
                calendarTranslation            = $event.data('calendar-translation');

            function hasPassed() {
                return now > endTimestamp;
            }

            function isCurrent() {
                return startTimestampMinus180seconds <= now && endTimestamp > now;
            }

            function isLaterThisDay() {
                return eventDay === dayNow &&
                           startTimestampMinus180seconds > now &&
                           eventMonth === monthNow &&
                           eventYear === yearNow;
            }

            function inTheFuture() {
                return now < endTimestamp;
            }

            function showEventMissedButton() {
                $event.find('.join-live-event, .calendar-popup-wrapper, .is-live-event').hide();
                $event.find('.event-passed').fadeIn();
            }

            function showJoinLiveEventButton() {
                $event.find('.calendar-popup-wrapper, .event-passed, .is-live-event').hide();
                $event.find('.join-live-event').fadeIn();
            }

            function showWillBeLiveLaterTodayInfo() {
                $event.find('.join-live-event, .event-passed').hide();
                $event.find('.is-live-event, .calendar-popup-wrapper').fadeIn();
            }

            function showIsNotOnThisDayInfo() {
                $event.find('.join-live-event, .event-passed').hide();
                $event.find('.calendar-popup-trigger-span').text(calendarTranslation);
                $event.find('.is-live-event, .calendar-popup-wrapper').fadeIn();
            }

            function toggleAddToCalendarOptions() {
                $event.find('.calendar-popup-trigger').click(function() {
                    var $calendarPopup = $event.find('.calendar-popup');
                    $calendarPopup.fadeToggle();
                    if ($calendarPopup.hasClass('is-visible')) {
                        $calendarPopup.removeClass('is-visible');
                    } else {
                        setTimeout(function() {
                            $calendarPopup.addClass('is-visible');
                        }, 100);
                    }
                });
            }

            function setTimerToStartEvent() {
                var delay = startTimestampMinus180seconds - now;
                setTimeout(showJoinLiveEventButton, delay);
            }

            function setTimerToEndEvent() {
                var delay = endTimestamp - now;
                setTimeout(showEventMissedButton, delay);
            }

            if (hasPassed()) {
                showEventMissedButton();
            } else if (isCurrent()) {
                showJoinLiveEventButton();
                setTimerToEndEvent();
            } else if (isLaterThisDay()) {
                toggleAddToCalendarOptions();
                showWillBeLiveLaterTodayInfo();
                setTimerToStartEvent();
                setTimerToEndEvent();
            } else if (inTheFuture()) {
                toggleAddToCalendarOptions();
                showIsNotOnThisDayInfo();
            }
        });

        $('body').click(function() {
            $('.calendar-popup.is-visible').each(function() {
                $(this).removeClass('is-visible').hide();
            });
        });

        return this;
    };
}(jQuery));
